/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ReleaseResponseDto } from '../model';
/**
 * OrderReleasesApi - axios parameter creator
 */
export const OrderReleasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (referenceNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/OrderReleases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['ReferenceNumber'] = referenceNumber;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderReleasesApi - functional programming interface
 */
export const OrderReleasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderReleasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(referenceNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReleaseResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(referenceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderReleasesApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderReleasesApi - factory interface
 */
export const OrderReleasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderReleasesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(referenceNumber?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReleaseResponseDto>> {
            return localVarFp.get(referenceNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderReleasesApi - object-oriented interface
 */
export class OrderReleasesApi extends BaseAPI {
    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(referenceNumber?: string, options?: RawAxiosRequestConfig) {
        return OrderReleasesApiFp(this.configuration).get(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }
}

